import { SourceContextProvider } from "react-admin";

/**
 * Escapes the SimpleFormIterator's SourceContext: child inputs use their
 * `source` as-is, absolute from the form root.
 *
 * Needed for UI helper arrays that live at the form root in parallel to the
 * iterated array (e.g. `restaurantProduct`, which only filters the products
 * query and enables the select) instead of living inside each item.
 *
 * Without this, react-admin 5 would prefix the source with the item's path
 * (`products.<i>`) and turn the array's scalar element into an object, breaking
 * the payload: "Cast to ObjectId failed for value
 * { restaurantProduct: [ null ] }".
 *
 * Note: it also intercepts `getLabel`, so inputs inside must pass an explicit
 * `label` — it is not auto-translated from the field name.
 */
const absoluteSourceContext = {
  getSource: (source) => source,
  getLabel: (source) => source,
};

const AbsoluteSource = ({ children }) => (
  <SourceContextProvider value={absoluteSourceContext}>
    {children}
  </SourceContextProvider>
);

export default AbsoluteSource;
